import React, { useState, useEffect } from 'react'
import { Main, MainBody, MainTop, MainTopTitle } from '@/components/Layout'
import Resx from '@/components/Resx'
import context from '@/context'
import { BsrsGrid, Column, commandColumnProps, DateCell, DateFilterCell } from '@/components/BsrsGrid'
import { format } from '@/utils/StringUtilities'
import { useBackgroundJobTracking } from '@/hooks/useBackgroundJobRunning'
import { Button } from '@/components/button'
import { localized } from '@/decorators/localized'
import { useSignalR } from '@/hooks/useSignalR'
import getComponentKey from '@/utils/getComponentKey'

const InstitutionReportGroups = ({ localize, forecasting }) => {
  const [isReportGeneratedToday, setIsReportGeneratedToday] = useState(false)
  const { running: triggerInstitutionReportGroupGenerationRunning, start: onTriggerInstitutionReportGroupGeneration } = useBackgroundJobTracking(
    context.api.temporaryJobService.triggerInstitutionReportGroupGeneration
  )
  const [gridKey, setGridKey] = useState(getComponentKey())

  useSignalR('institutionReportsRegenerated', () => {
    setGridKey(getComponentKey())
  }, [])

  useEffect(() => {
    // Check if the report was generated today when the component mounts
    const checkReportStatus = async () => {
      const result = await context.api.institutionReportGroupService.isReportGeneratedToday()
      setIsReportGeneratedToday(result)
    }

    checkReportStatus()
  }, [])

  return (
    <Main>
      <MainTop>
        <MainTopTitle>
          <Resx name='Menu.InstitutionReportGroups' />
        </MainTopTitle>
      </MainTop>
      <MainBody>
        <Button
          onClick={onTriggerInstitutionReportGroupGeneration}
          disabled={triggerInstitutionReportGroupGenerationRunning || isReportGeneratedToday}
          style={{ margin: '20px 0' }}
        >
          Generate ICBS report for today
        </Button>
        <BsrsGrid
          persistenceId={'institution-report-groups'}
          dataSource={request => context.api.institutionReportGroupService.getTableData(localize('Common.CBI'), forecasting, request)}
          defaultSort={[{ field: 'creationTime', dir: 'desc' }]}
          lastReloadedAt={gridKey}
        >
          <Column field='id' title={localize('Common.Id')} filter='numeric' editable={false} />
          <Column field='name' title={localize('Common.ArabicName')} editable={false} />
          <Column field='latinName' title={localize('Common.LatinName')} editable={false} />
          <Column field='creationTime' title={localize('Common.CreationTime')} filter='date' cell={DateCell} filterCell={DateFilterCell} editable={false} />
          <Column {...commandColumnProps({ detailUrl: x => format('/icbs-report-groups/{0}/icbs-reports', x.id) })} title=' ' width={150} />
        </BsrsGrid>
      </MainBody>
    </Main>
  )
}

export default localized()(InstitutionReportGroups)



// WEBPACK FOOTER //
// ./src/internal-app/pages/institutionReports/institutionReportGroups.js